<template>
  <v-autocomplete
    :value="value"
    :items="servicesList"
    :label="$t('SERVICES.ITEMS')"
    :search-input.sync="search"
    :counter="counter"
    :menu-props="menuProps"
    item-value="id"
    item-text="title"
    multiple
    chips
    small-chips
    deletable-chips
    append-outer-icon="mdi-close"
    v-bind="$attrs"
    v-on="listeners"
  ></v-autocomplete>
</template>

<script>
import { mapCacheActions } from 'vuex-cache';
import clearableSelectFilter from '../filters/mixins/clearableSelectFilter';

export default {
  name: 'ServicesFilter',

  mixins: [clearableSelectFilter],

  data() {
    return {
      servicesList: []
    };
  },

  mounted() {
    this.retrieveEmployeeServices().then(({ data }) => {
      this.servicesList = data.data;
    });
  },

  methods: {
    ...mapCacheActions('service', ['retrieveEmployeeServices'])
  }
};
</script>

<style scoped></style>
